import apis from 'src/const/apis';

// 有降级需求的api, 发现下面的接口有降级情况后，会在页面显示降级提示框
export const APIDownGradeList = [
  // dashboard部分的降级接口
  // v3接口
  apis.dashboard.newDashboardData,
  apis.dashboard.newDashboardAccountStatus,
  apis.dashboard.newDashboardSuggestion,
  apis.dashboard.optimizeDashboardSuggestion,
  apis.dashboard.newDashboardAudience,
  apis.dashboard.newDashboardDeparting,
  // campaign 层级列表部分的降级接口
  // v3
  apis.ad.newStatisticList,
  apis.campaign.newStatisticList,
  apis.creative.newStatisticList,
  // view data 层级涉及到降级的接口
  // v3
  apis.ad.new_report_stat,
  apis.campaign.new_report_stat,
  apis.creative.new_report_stat,
  apis.ad.new_breakdown_report_stat,
  apis.campaign.new_breakdown_report_stat,
  apis.creative.new_breakdown_report_stat,
];

// TTP 降级，优先级低于上面的统计降级
export const APITTPDowngradeList = [
  // 列表接口
  apis.ad.newStatisticList,
  apis.campaign.newStatisticList,
  apis.creative.newStatisticList,
  // viewdata 接口
  apis.ad.new_report_stat,
  apis.campaign.new_report_stat,
  apis.creative.new_report_stat,
  apis.ad.ttp_breakdown_report_stat,
  apis.campaign.ttp_breakdown_report_stat,
  apis.creative.ttp_breakdown_report_stat,
  // viewdata rf 接口
  apis.ad.new_frequency_download_trail_url,
  apis.ad.new_frequency_projected_stat,
];
